import { isNullOrUndefined, addClass, extend } from '@syncfusion/ej2-base';
import { appendChildren, setStyleAndAttributes, addFixedColumnBorder, addStickyColumnPosition, resetColandRowSpanStickyPosition } from '../base/util';
import * as literals from '../base/string-literals';
/**
 * Edit render module is used to render grid edit row.
 *
 * @hidden
 */
export class InlineEditRender {
    /**
     * Constructor for render module
     *
     * @param {IGrid} parent - returns the IGrid
     */
    constructor(parent) {
        this.parent = parent;
    }
    addNew(elements, args) {
        this.isEdit = false;
        let tbody;
        if ((this.parent.frozenRows || ((this.parent.enableVirtualization || this.parent.enableInfiniteScrolling) &&
            this.parent.editSettings.showAddNewRow)) && this.parent.editSettings.newRowPosition === 'Top') {
            tbody = this.parent.getHeaderTable().querySelector(literals.tbody);
        }
        else {
            tbody = this.parent.getContentTable().querySelector(literals.tbody);
        }
        args.row = this.parent.createElement('tr', { className: 'e-row e-addedrow' });
        if (this.parent.getContentTable().querySelector('.e-emptyrow') && !this.parent.editSettings.showAddNewRow) {
            const emptyRow = this.parent.getContentTable().querySelector('.e-emptyrow');
            emptyRow.parentNode.removeChild(emptyRow);
            if (this.parent.frozenRows && this.parent.element.querySelector('.e-frozenrow-empty')) {
                this.parent.element.querySelector('.e-frozenrow-empty').classList.remove('e-frozenrow-empty');
            }
        }
        if (this.parent.editSettings.newRowPosition === 'Top') {
            tbody.insertBefore(args.row, tbody.firstChild);
        }
        else {
            tbody.appendChild(args.row);
        }
        args.row.appendChild(this.getEditElement(elements, false, undefined, args, true));
        this.parent.editModule.checkLastRow(args.row, args);
    }
    update(elements, args) {
        this.isEdit = true;
        const tdElement = [].slice.call(args.row.querySelectorAll('td.e-rowcell'));
        args.row.innerHTML = '';
        args.row.appendChild(this.getEditElement(elements, true, tdElement, args, true));
        args.row.classList.add(literals.editedRow);
        this.parent.editModule.checkLastRow(args.row, args);
    }
    // eslint-disable-next-line max-len
    getEditElement(elements, isEdit, tdElement, args, isFrozen) {
        const gObj = this.parent;
        let gLen = 0;
        const isDetail = !isNullOrUndefined(gObj.detailTemplate) || !isNullOrUndefined(gObj.childGrid) ? 1 : 0;
        if (gObj.allowGrouping) {
            gLen = gObj.groupSettings.columns.length;
        }
        const td = this.parent.createElement('td', {
            className: 'e-editcell e-normaledit',
            attrs: {
                colspan: (gObj.getCurrentVisibleColumns(this.parent.enableColumnVirtualization).length +
                    this.parent.getIndentCount()).toString()
            }
        });
        const form = args.form =
            this.parent.createElement('form', { id: gObj.element.id + 'EditForm', className: 'e-gridform' });
        if (this.parent.editSettings.template) {
            this.appendChildren(form, args.rowData, isFrozen);
            td.appendChild(form);
            return td;
        }
        const table = this.parent.createElement('table', { className: 'e-table e-inline-edit', attrs: { cellspacing: '0.25', role: 'grid' } });
        table.appendChild(gObj.getContentTable().querySelector(literals.colGroup).cloneNode(true));
        const tbody = this.parent.createElement(literals.tbody, { attrs: { role: 'rowgroup' } });
        const tr = this.parent.createElement('tr');
        if (this.parent.rowHeight) {
            tr.style.height = this.parent.rowHeight + 'px';
        }
        let i = 0;
        if (isDetail) {
            tr.insertBefore(this.parent.createElement('td', { className: 'e-detailrowcollapse' }), tr.firstChild);
        }
        if (gObj.isRowDragable()) {
            tr.appendChild(this.parent.createElement('td', { className: 'e-dragindentcell' }));
        }
        while (i < gLen) {
            tr.appendChild(this.parent.createElement('td', { className: 'e-indentcell' }));
            i++;
        }
        let m = 0;
        i = 0;
        let inputValue;
        let isFirstVisibleCell = true;
        const cols = args.isCustomFormValidation ? this.parent.columnModel : gObj.getColumns();
        while ((isEdit && m < tdElement.length && i < cols.length) || i < cols.length) {
            const span = isEdit && tdElement[parseInt(m.toString(), 10)] ?
                tdElement[parseInt(m.toString(), 10)].getAttribute('colspan') : null;
            const col = cols[parseInt(i.toString(), 10)];
            inputValue = (elements[col.uid]).value;
            inputValue = !isNullOrUndefined(inputValue) ? inputValue : '';
            const td = this.parent.createElement('td', { className: literals.rowCell, attrs: { 'colspan': span ? span : '' } });
            td.style.cssText = col.textAlign ? `text-align: ${col.textAlign};` : '';
            if (col.visible) {
                td.appendChild(elements[col.uid]);
                if (this.parent.rowRenderingMode === 'Vertical') {
                    setStyleAndAttributes(td, { 'data-cell': col.headerText });
                    if (i === 0) {
                        td.classList.add('e-responsive-editcell');
                    }
                }
                if (col.editType === 'booleanedit') {
                    td.classList.add('e-boolcell');
                }
                else if (col.commands || col.commandsTemplate) {
                    addClass([td], 'e-unboundcell');
                }
                if (!this.parent.enableRtl && (gObj.gridLines === 'Vertical' || gObj.gridLines === 'Both') && isFirstVisibleCell) {
                    if (gLen) {
                        td.classList.add('e-grid-group-first-cell');
                    }
                    else if ((this.parent.renderModule && this.parent.renderModule.isFirstColumnHidden) &&
                        !(this.parent.allowRowDragAndDrop || this.parent.childGrid || this.parent.detailTemplate)) {
                        td.classList.add('e-first-visible-cell');
                    }
                    isFirstVisibleCell = false;
                }
            }
            else {
                td.classList.add('e-hide');
            }
            if (this.parent.isFrozenGrid()) {
                addStickyColumnPosition(this.parent, col, td);
                if (this.parent.isSpan) {
                    const colSpan = td.getAttribute('colspan') ? parseInt(td.getAttribute('colspan'), 10) : 1;
                    resetColandRowSpanStickyPosition(this.parent, col, td, colSpan);
                }
                if (this.parent.enableColumnVirtualization) {
                    if (col.freeze === 'Left' && !isNullOrUndefined(col.valueX)) {
                        td.style.left = (col.valueX - this.parent.translateX) + 'px';
                    }
                    else if (col.freeze === 'Right' && !isNullOrUndefined(col.valueX)) {
                        td.style.right = (col.valueX + this.parent.translateX) + 'px';
                    }
                    else if (col.freeze === 'Fixed') {
                        td.style.left = (this.parent.leftrightColumnWidth('left') - this.parent.translateX) + 'px';
                        td.style.right = (this.parent.leftrightColumnWidth('right') + this.parent.translateX) + 'px';
                    }
                }
            }
            td.setAttribute('aria-label', inputValue + this.parent.localeObj.getConstant('ColumnHeader') + col.headerText);
            tr.appendChild(td);
            i = span ? i + parseInt(span, 10) : i + 1;
            m++;
        }
        addFixedColumnBorder(tr);
        tbody.appendChild(tr);
        table.appendChild(tbody);
        form.appendChild(table);
        td.appendChild(form);
        return td;
    }
    removeEventListener() {
        //To destroy the renderer
    }
    appendChildren(form, data, isFrozen) {
        const dummyData = extend({}, data, { isAdd: !this.isEdit, isFrozen: isFrozen }, true);
        const editTemplateID = this.parent.element.id + 'editSettingsTemplate';
        if (this.parent.isReact && typeof (this.parent.editSettings.template) !== 'string' &&
            !(this.parent.editSettings.template.prototype &&
                this.parent.editSettings.template.prototype.CSPTemplate)) {
            this.parent.getEditTemplate()(dummyData, this.parent, 'editSettingsTemplate', editTemplateID, null, null, form);
            this.parent.renderTemplates();
        }
        else {
            appendChildren(form, this.parent.getEditTemplate()(dummyData, this.parent, 'editSettingsTemplate', editTemplateID, null, null, null, this.parent.root));
        }
        // eslint-disable-next-line
        const setRules = () => {
            const cols = this.parent.getColumns();
            for (let i = 0; i < cols.length; i++) {
                if (cols[parseInt(i.toString(), 10)].validationRules) {
                    this.parent.editModule.formObj.rules[cols[parseInt(i.toString(), 10)].field] =
                        cols[parseInt(i.toString(), 10)].validationRules;
                }
            }
        };
    }
}
